import { render, staticRenderFns } from "./MyHubAppLink.vue?vue&type=template&id=59fab274"
import script from "./MyHubAppLink.vue?vue&type=script&lang=js"
export * from "./MyHubAppLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports